import { createPortal } from 'react-dom';

interface TicketPrecobranzaMantenimientoProps {
  precobranza: {
    bus_padron: string;
    bus_placa?: string | null;
    periodo: string;
    monto: number | string;
    fecha_impresion: string;
    conceptos?: { tipo: string; descripcion: string; monto: number | string }[] | null;
  };
  etiquetaPeriodo: (periodo: string) => string;
}

const TicketPrecobranzaMantenimiento = ({ precobranza, etiquetaPeriodo }: TicketPrecobranzaMantenimientoProps) => {
  const monto = typeof precobranza.monto === 'string' ? parseFloat(precobranza.monto) : precobranza.monto;
  // Recibos viejos (antes de los conceptos) no traen la lista: eran solo mantenimiento.
  const conceptos = precobranza.conceptos && precobranza.conceptos.length > 0
    ? precobranza.conceptos
    : [{ tipo: 'mantenimiento', descripcion: 'Mantenimiento (cuota fija)', monto }];
  const incluyeMantenimiento = conceptos.some(c => c.tipo === 'mantenimiento');
  return createPortal(
    <div className="ticket-print-only">
      <p className="centro bold titulo">SISTEMA MANTSILA</p>
      <p className="centro">Recibo de Precobranza</p>
      <hr />
      <p><span className="bold">Bus/Padrón:</span> {precobranza.bus_padron}</p>
      {precobranza.bus_placa && <p><span className="bold">Placa:</span> {precobranza.bus_placa}</p>}
      {incluyeMantenimiento && <p><span className="bold">Periodo:</span> {etiquetaPeriodo(precobranza.periodo)}</p>}
      <p><span className="bold">Fecha:</span> {new Date(precobranza.fecha_impresion).toLocaleString('es-PE')}</p>
      <hr />
      <p className="bold">Concepto</p>
      {conceptos.map((c, i) => (
        <div className="fila" key={i}>
          <span>{c.descripcion}</span>
          <span>S/ {Number(c.monto).toFixed(2)}</span>
        </div>
      ))}
      <hr />
      <div className="fila bold total"><span>A COBRAR:</span><span>S/ {monto.toFixed(2)}</span></div>
      <hr />
      <p className="centro" style={{ marginTop: '2mm' }}>
        Este comprobante es un AVISO DE COBRO, no es un pago registrado.
      </p>
      <p className="centro" style={{ marginTop: '2mm', fontSize: '2mm' }}>SOFTWARE DISEÑADO POR TU LUGAR INTELIGENTE 931398916</p>
    </div>,
    document.body
  );
};

export default TicketPrecobranzaMantenimiento;
